import React, {useEffect, useState} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function BiomarkerList(props) {
    const {t} = useTranslation();
    const [biomarkers, setBiomarkers] = useState([]);
    const [biomarker, setBiomarker] = useState(-1);
    const [biomarkerObject, setBiomarkerObject] = useState(null);
    const [show, setShow] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentBiomarker = (biomarker_id, type) => {
        setBiomarker(biomarker_id);
        const found = biomarkers.find(b => b.id == biomarker_id);
        setBiomarkerObject(found);
        
        if (type === 'delete') {
            setShow(true);
        } else if (type === 'view') {
            setShowDetailModal(true);
        }
    };

    const handleClose = () => {
        setShow(false);
        setShowDetailModal(false);
    }

    const deleteBiomarker = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(
            API_URL + 'biomarker/' + biomarker + '/delete'
        ).then((response) => {
            if (response.data.status) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    }

    useEffect(() => {
        axios.get(API_URL + 'biomarker').then((response) => {
            if (response.data.status) {
                setBiomarkers(response.data.data);
            } else {
                alertify.error(response.data.message);
            }
        }).catch((error) => {
            alertify.error("Something went wrong. Try again!");
        });
    }, []);

    // Initialize DataTable AFTER biomarkers are set and rendered
    useEffect(() => {
        if (biomarkers.length) {
            // Destroy previous instance if it exists to prevent errors
            if ($.fn.DataTable.isDataTable("#biomarker_table")) {
                $("#biomarker_table").DataTable().destroy();
            }

            $("#biomarker_table").DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                autoWidth: false,
            });
        }
    }, [biomarkers]);

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Biomarker List")}>
                            <CardHeaderToolbar>
                                <Link to="/biomarker/create" className="btn btn-primary btn-sm mx-3">
                                    {t("Create Biomarker")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow: 'auto'}}>

                            <table id="biomarker_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Unit")}</th>
                                    <th>{t("Biomarker machine code")}</th>
                                    <th>{t("Machine")}</th>
                                    <th>{t("Default Result")}</th>
                                    {/* <th>{t("Normal Ranges Count")}</th> */}
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {biomarkers.length > 0 ? (
                                    biomarkers.map((biomarker, index) => (
                                        <tr key={`biomarker-` + biomarker.id}>
                                            <td>{index + 1}</td>
                                            <td>{biomarker.name}</td>
                                            <td>{biomarker.unit ? biomarker.unit.name : '-'}</td>
                                            <td>{biomarker.machine_code || '-'}</td>
                                            <td>{biomarker.machine ? (biomarker.machine.short_code ? `${biomarker.machine.short_code} (${biomarker.machine.name})` : biomarker.machine.name) : '-'}</td>
                                            <td>{biomarker.default_result || '-'}</td>
                                            {/* <td>
                                                <span className="badge badge-info">
                                                    {biomarker.normal_ranges ? biomarker.normal_ranges.length : 0} {t("ranges")}
                                                </span>
                                            </td> */}
                                            <td>
                                                <a
                                                    onClick={() => setCurrentBiomarker(biomarker.id, 'view')}
                                                    className="btn btn-icon btn-light btn-hover-info btn-sm mx-1"
                                                    title={t("View Details")}
                                                >
                                                    <span className="svg-icon svg-icon-md svg-icon-info">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}/>
                                                    </span>
                                                </a>
                                                <Link to={`/biomarker/edit/${biomarker.id}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                                                      title={t("Edit")}
                                                >
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}/>
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentBiomarker(biomarker.id, 'delete')}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
                                                    title={t("Delete")}
                                                >
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7}>{t("No Biomarkers Found")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Delete Confirmation Modal */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Biomarker")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t("Are you sure you want to delete this biomarker?")}
                    {biomarkerObject && (
                        <p className="mt-2"><strong>{biomarkerObject.name}</strong></p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="danger" onClick={deleteBiomarker} disabled={disabled}>
                        {t("Delete")}
                        <span dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* View Detail Modal */}
            <Modal show={showDetailModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{t("Biomarker Details")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {biomarkerObject && (
                        <>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <strong>{t("Name")}:</strong> {biomarkerObject.name}
                                </Col>
                                <Col md={6}>
                                    <strong>{t("Unit")}:</strong> {biomarkerObject.unit ? biomarkerObject.unit.name : '-'}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <strong>{t("Machine Code")}:</strong> {biomarkerObject.machine_code || '-'}
                                </Col>
                                <Col md={6}>
                                    <strong>{t("Machine")}:</strong> {biomarkerObject.machine ? (biomarkerObject.machine.short_code ? `${biomarkerObject.machine.short_code} (${biomarkerObject.machine.name})` : biomarkerObject.machine.name) : '-'}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <strong>{t("Default Result")}:</strong> {biomarkerObject.default_result || '-'}
                                </Col>
                            </Row>
                            <hr/>
                            <h5>{t("Normal Ranges")}</h5>
                            {biomarkerObject.normal_ranges && biomarkerObject.normal_ranges.length > 0 ? (
                                <Table striped bordered hover size="sm">
                                    <thead>
                                    <tr>
                                        <th>{t("Gender")}</th>
                                        <th>{t("Age Range")}</th>
                                        <th>{t("Normal Values")}</th>
                                        <th>{t("Label")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {biomarkerObject.normal_ranges.map((range, idx) => (
                                        <tr key={idx}>
                                            <td>{range.gender}</td>
                                            <td>{range.from_age} - {range.to_age}</td>
                                            <td>{range.minimum_value} - {range.maximum_value}</td>
                                            <td>{range.label || '-'}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p>{t("No normal ranges defined")}</p>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
